<div id="groupServices" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row"
            fxLayoutAlign.gt-sm="space-between center">

            <!-- APP TITLE -->

            <div class="logo mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="'/tenant/'+ TenantId +'/location/'">
                    <mat-icon>{{'arrow_back' | translate}}</mat-icon>
                </button>
                <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                    {{'GROUPSERVICE_ENTRY.groupService' | translate}}
                </span>
            </div>
            <!-- / APP TITLE -->

            <!-- SEARCH -->
            <div class="search-wrapper mx-32 mx-md-0">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon> {{'LOCATION_LIST.search' | translate}}</mat-icon>
                    <input (keyup)="groupServiceSearch($event.target.value)" placeholder="{{'GROUPSERVICE_ENTRY.searchGroupService' | translate}}">
                </div>
            </div>

     
            <!-- / SEARCH -->

            <!-- ADD BUTTON -->
            <button mat-raised-button [routerLink]="'/group-service/tenant/'+ TenantId +'/location/' + locationId + '/add'"
                class="add-groupservice-button fuse-white mt-24 mt-md-0">
                <span>{{'GROUPSERVICE_ENTRY.addNewGroupService' | translate}}</span>
            </button>
            <!-- / ADD BUTTON -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="list-skeleton" *ngIf="loaderService.isLoading ">
                <ngx-skeleton-loader
                    [theme]="{ width: '100%', height: '35px'}"
                    animation="progress"
                    count="10">
                </ngx-skeleton-loader>
            </div>
            <mat-table  *ngIf="!loaderService.isLoading "
            class="groupService-table custom-table" #table [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}"
                fusePerfectScrollbar>

                <!-- ID Column -->
                <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'GROUPSERVICE_ENTRY.id' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let groupService" [routerLink]="'/group-service/id/' + groupService.id +'/tenant/' +TenantId + '/location/' +locationId +'/edit' ">
                        <p class="text-truncate">{{groupService.id}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="image">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'TENANT_LIST.logo' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let groupService" class="image-column">
                        <!-- ADD FILE BUTTON -->
                        <div *ngIf="groupService.icon ==null" class="file-uploader">
                            <input hidden type="file" #fileInput [accept]="allowedFiles" />
                            <button mat-mini-fab class="add-file-btn" (click)="fileInput.click()" aria-label="Add file"
                                [@animate]="{value:'*', params:{delay:'300ms',scale:'0.2'}}">
                                <mat-icon>add</mat-icon>

                            </button>
                    
                        </div>
                        <div *ngIf="groupService.icon !=null">
                            <img src="{{'data:image/jpg;base64,' + groupService.icon}}" />
                        </div>
                    </mat-cell>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'GROUPSERVICE_ENTRY.name' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let groupService" [routerLink]="'/group-service/add/location/' + groupService.id">
                        <p class="text-truncate">{{groupService.name}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'GROUPSERVICE_ENTRY.actions' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let groupService">


                        <mat-icon class="logo-icon cursorIcon"
                        (click)="edit(groupService.id)" 
                            [@animate]="{value:'*',params:{delay:'200ms',scale:'0.4'}}"
                            matTooltip="{{'GROUPSERVICE_ENTRY.editGroupService' | translate}}">
                            edit
                        </mat-icon>

                        <mat-icon class="logo-icon mx-1 cursorIcon" (click)="deleteGroupService(groupService.id)"
                            [@animate]="{value:'*',params:{delay:'275ms',scale:'0.6'}}"
                            matTooltip="{{'GROUPSERVICE_ENTRY.deleteGroupService' | translate}}">
                            delete_forever
                        </mat-icon>

                    </mat-cell>
                </ng-container>


                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let groupService; columns: displayedColumns;" class="groupService" matRipple>
                    <!-- [routerLink]="'/category/add/' + category.id" -->
                </mat-row>

            </mat-table>

            <mat-paginator 
              [length]="length"
              [pageIndex]="pageIndex - 1"
              [pageSize]="pageSize"
              (page)='groupServicPagenation($event)'
              [pageSizeOptions]="pageSizeOptions">
          </mat-paginator>

        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>